import { CUSTOMER_IDS } from '../constants/customerHelper.js'

const partNumberGenerators = {
  [CUSTOMER_IDS.TME]: publication => publication.title,
  [CUSTOMER_IDS.NORDICS]: (publication, language) => {
    const { model, year } = publication.product
    return `${model}-${year}-${publication.publicationType}-${language}`
  }
}

const defaultPartNumberGenerator = (publication, language) => {
  const { model, modelType, year, trim } = publication.product
  return `${model}-${modelType || trim}-${year}-${publication.publicationType}-${language}`
}

export const generatePartNumber = customerId => (publication, language) => {
  const generator = partNumberGenerators[customerId] || defaultPartNumberGenerator
  return generator(publication, language)
}
